import { useEffect, useState } from 'react';

function useImageModal(isOpen: boolean) {
    const [isHide, setIsHide] = useState<boolean>(true);
    const [isNone, setIsNone] = useState<boolean>(true);

    useEffect(() => {
        if (isOpen) {
            setIsNone(false);
            const timeout = setTimeout(() => {
                setIsHide(false);
            }, 100);
            return () => clearTimeout(timeout);
        }
        setIsHide(true);
        const timeout = setTimeout(() => {
            setIsNone(true);
        }, 300);
        return () => clearTimeout(timeout);
    }, [isOpen]);
    return {
        isNone, isHide,
    };
}

export default useImageModal;
